// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2JPD0","additionalInfo":"AgreementModal_additionalInfo__4VZIR"};